import { FC } from 'react';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Search } from 'lucide-react';

interface CityFeesFiltersProps {
  search: string;
  onSearchChange: (search: string) => void;
  archivedFilter: 'all' | 'active' | 'archived';
  onArchivedFilterChange: (filter: 'all' | 'active' | 'archived') => void;
}

export const CityFeesFilters: FC<CityFeesFiltersProps> = ({
  search,
  onSearchChange,
  archivedFilter,
  onArchivedFilterChange,
}) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-end">
      {/* Search */}
      <div className="flex-1 w-full">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
          <Input
            id="search"
            type="text"
            placeholder="Search by city or state..."
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-10 w-full"
          />
        </div>
      </div>

      {/* Status Filter */}
      <div className="w-full sm:w-48">
        <Select value={archivedFilter} onValueChange={onArchivedFilterChange}>
          <SelectTrigger id="status-filter" className="w-full">
            <SelectValue placeholder="Select status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All</SelectItem>
            <SelectItem value="active">Active</SelectItem>
            <SelectItem value="archived">Archived</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
